export default class Employee {
  name: string = "";
  code: string = "";
  password: string = "";
}
